import { lazy, Suspense } from 'react';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import { AppProviders } from '@/providers/AppProviders';
import { ProtectedRoute } from '@/app/ProtectedRoute';
import { AppShell } from '@/layouts/AppShell';
import { LoginPage } from '@/pages/LoginPage';
import { ErrorBoundary } from '@/components/ui/ErrorBoundary';
import { RouteFallback } from '@/app/RouteFallback';

const DashboardPage      = lazy(() => import('@/pages/DashboardPage').then((m) => ({ default: m.DashboardPage })));
const PatientsPage       = lazy(() => import('@/pages/PatientsPage').then((m) => ({ default: m.PatientsPage })));
const PatientDetailPage  = lazy(() => import('@/pages/PatientDetailPage').then((m) => ({ default: m.PatientDetailPage })));
const SchedulePage       = lazy(() => import('@/pages/SchedulePage').then((m) => ({ default: m.SchedulePage })));
const ServicesPage       = lazy(() => import('@/pages/ServicesPage').then((m) => ({ default: m.ServicesPage })));
const PackagesPage       = lazy(() => import('@/pages/PackagesPage').then((m) => ({ default: m.PackagesPage })));
const InventoryPage      = lazy(() => import('@/pages/InventoryPage').then((m) => ({ default: m.InventoryPage })));
const AssessmentsPage    = lazy(() => import('@/pages/AssessmentsPage').then((m) => ({ default: m.AssessmentsPage })));
const PlansPage          = lazy(() => import('@/pages/PlansPage').then((m) => ({ default: m.PlansPage })));
const SessionsPage       = lazy(() => import('@/pages/SessionsPage').then((m) => ({ default: m.SessionsPage })));
const NutritionPage      = lazy(() => import('@/pages/NutritionPage').then((m) => ({ default: m.NutritionPage })));
const BillingPage        = lazy(() => import('@/pages/BillingPage').then((m) => ({ default: m.BillingPage })));
const FinancePage        = lazy(() => import('@/pages/FinancePage').then((m) => ({ default: m.FinancePage })));
const ReportsPage        = lazy(() => import('@/pages/ReportsPage').then((m) => ({ default: m.ReportsPage })));
const FilesPage          = lazy(() => import('@/pages/FilesPage').then((m) => ({ default: m.FilesPage })));
const EmployeesPage      = lazy(() => import('@/pages/EmployeesPage').then((m) => ({ default: m.EmployeesPage })));
const SettingsPage       = lazy(() => import('@/pages/SettingsPage').then((m) => ({ default: m.SettingsPage })));
const MorePage           = lazy(() => import('@/pages/MorePage').then((m) => ({ default: m.MorePage })));

export default function App() {
  return (
    <AppProviders>
      <ErrorBoundary>
        <BrowserRouter>
          <Suspense fallback={<RouteFallback />}>
            <Routes>
              <Route path="/login" element={<LoginPage />} />
              <Route
                element={
                  <ProtectedRoute>
                    <AppShell />
                  </ProtectedRoute>
                }
              >
                <Route index element={<DashboardPage />} />
                <Route path="patients" element={<PatientsPage />} />
                <Route path="patients/:id" element={<PatientDetailPage />} />
                <Route path="schedule" element={<SchedulePage />} />
                <Route path="services" element={<ServicesPage />} />
                <Route path="packages" element={<PackagesPage />} />
                <Route path="inventory" element={<InventoryPage />} />
                <Route path="assessments" element={<AssessmentsPage />} />
                <Route path="plans" element={<PlansPage />} />
                <Route path="sessions" element={<SessionsPage />} />
                <Route path="nutrition" element={<NutritionPage />} />
                <Route path="billing" element={<BillingPage />} />
                <Route path="finance" element={<FinancePage />} />
                <Route path="reports" element={<ReportsPage />} />
                <Route path="files" element={<FilesPage />} />
                <Route path="employees" element={<EmployeesPage />} />
                <Route path="more" element={<MorePage />} />
                <Route path="settings" element={<SettingsPage />} />
              </Route>
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </Suspense>
        </BrowserRouter>
      </ErrorBoundary>
    </AppProviders>
  );
}
